import React from "react";
import { ShiftContainer } from "../shift/container";
import { VERTICALS } from "../../utils/constants";

const SharedShiftList = ShiftContainer("ShiftList");

/**
 * Courier shifts reuse the home-collection shift module (schedules, attendance)
 * filtered by vertical=COURIER.
 */
const CourierShiftsList = props => (
  <SharedShiftList
    {...props}
    scheduleVertical={VERTICALS.COURIER}
    riderSearchVertical={VERTICALS.COURIER}
    courierModule
  />
);

export default CourierShiftsList;
